
export default {
  name: 'BackPageButton',

  props: {
    textButton: {
      type: String,
      default: '',
    },
  },
};
